export default {
    code: 'ta',
    htmlLang: 'ta',
    ogLocale: 'ta_IN',
    selectLabel: 'தமிழ்',
    meta: {
        home: {
            title: 'கிளினிக் பெர்கிஜியன் இர்மா அரியாண்டி — Wear Your Smile | ஜொகூர் பாரு பல் மருத்துவமனை',
            description: 'ஜொகூர் பாருவில் பல் மருத்துவமனை — பிரேசஸ், clear aligners, FRC, சிர்க்கோனியா கிரீடம் & பிரிட்ஜ். நல்ல சிகிச்சை, நேர்மையான ஆலோசனை, வெளிப்படையான கட்டணம்.',
        },
    },
    nav: {
        home: 'முதற்பக்கம்',
        treatments: 'சிகிச்சைகள்',
        teen: 'Teen Smile',
        teenBadge: 'பெற்றோர் வழிகாட்டி',
        international: 'சர்வதேச நோயாளிகள்',
        kolum: 'Coffee With Dr. Irma',
        doctors: 'எங்கள் மருத்துவர்கள்',
        stories: 'நோயாளிகளின் கதைகள்',
        contact: 'தொடர்பு',
        book: 'நேரம் பதிவு',
        menu: 'மெனு',
        close: 'மூடு',
        language: 'மொழி',
        treatmentsMenu: [
            { slug: 'conventional-braces', title: 'பிரேசஸ்', desc: 'நம்பகமான பற்கள் நேர்த்தி' },
            { slug: 'clear-aligners', title: 'Clear Aligners', desc: 'குறைவாகத் தெரியும் தீர்வு' },
            { slug: 'frc', title: 'FRC', desc: 'பெரிய அறுவை இல்லாத முன் பல் மாற்று' },
            { slug: 'zirconia-crowns-bridges', title: 'சிர்க்கோனியா கிரீடம் & பிரிட்ஜ்', desc: 'வலுவான, அழகான செராமிக் மீட்டமைப்பு' },
            { slug: 'aesthetic-veneers', title: 'Aesthetic Veneers & Smile Makeover', desc: 'உங்களுக்காக வடிவமைக்கப்படும் புன்னகை' },
        ],
        digitalLink: { path: '/digital-dentistry', title: 'Digital Dentistry', desc: 'நவீன சிகிச்சைத் திட்டமிடலின் தொழில்நுட்பம்' },
        internationalMenu: [
            { path: '/international/singapore', title: 'சிங்கப்பூர்', desc: 'சிங்கப்பூரிலிருந்து வருவோருக்கு' },
            { path: '/international/indonesia-batam', title: 'இந்தோனேசியா / பத்தாம்', desc: 'பத்தாம் மற்றும் இந்தோனேசியாவிலிருந்து வருவோருக்கு' },
            { path: '/international', title: 'மேலோட்டம்', desc: 'எல்லை தாண்டிய சிகிச்சை எவ்வாறு' },
        ],
        doctorsMenu: [
            { path: '/doctors/dr-irma-ariandi', title: 'Dr. Irma (DDS, UKM)', desc: 'பல் மருத்துவர் · கல்வியாளர் · எழுத்தாளர்' },
            { path: '/doctors/dr-ariandi', title: 'Dr. Ariandi (DDS, UKM)', desc: 'பல் மருத்துவர்' },
        ],
    },
    cta: {
        whatsapp: 'WhatsApp செய்யுங்கள்',
        whatsappLong: 'கிளினிக்கை WhatsApp செய்யுங்கள்',
        book: 'நேரம் பதிவு',
        askIrma: 'Dr. Irma-விடம் கேளுங்கள்',
        explore: 'சிகிச்சைகளைப் பாருங்கள்',
        email: 'மின்னஞ்சல்',
    },
    journeySteps: [
        { k: '01', t: 'பரிசோதனை', d: 'நன்றாகப் பார்த்து, சரியாகக் கண்டறிதல்.' },
        { k: '02', t: 'விளக்கம்', d: 'நாங்கள் காண்பதை எளிய மொழியில் விளக்குகிறோம்.' },
        { k: '03', t: 'விருப்பங்கள்', d: 'அனைத்து நியாயமான விருப்பங்களும் முன்வைக்கப்படும்.' },
        { k: '04', t: 'கட்டணம்', d: 'சிகிச்சைக்கு முன் கட்டணம் விளக்கப்படும்.' },
        { k: '05', t: 'முடிவு', d: 'முடிவு உங்களுடையது. ஆலோசனை எங்களுடையது.' },
        { k: '06', t: 'சிகிச்சை', d: 'உங்கள் வேகத்தில் சிகிச்சை.' },
        { k: '07', t: 'தொடர் கண்காணிப்பு', d: 'நாங்கள் சரிபார்த்து, சரிசெய்து, கண்காணிப்போம்.' },
    ],
    journeyNote: 'ஒவ்வொரு நோயாளியும் வேறுபட்டவர். உண்மையான பாதையை மருத்துவர் பரிசோதனைக்குப் பிறகு விளக்குவார்.',
    home: {
        hero: {
            badge: 'Klinik Pergigian Irma Ariandi · ஜொகூர் பாரு',
            titleA: 'WEAR YOUR',
            titleB: 'SMILE.',
            sub: 'நல்ல பல் சிகிச்சை. நேர்மையான ஆலோசனை. வெளிப்படையான கட்டணம். மனிதநேயமான கவனிப்பு.',
            sub2: 'ஜொகூர் பாருவில் பற்கள் நேர்ப்பு, மீட்டமைப்பு மற்றும் அழகியல் பல் சிகிச்சை — கவனமாகத் திட்டமிட்டு, நேர்மையாக விளக்குகிறோம்.',
            chips: ['BRACES', 'CLEAR ALIGNERS', 'FRC', 'ZIRCONIA', 'VENEERS'],
            welcome: 'ஜொகூர், சிங்கப்பூர் மற்றும் இந்தோனேசியாவிலிருந்து வரும் நோயாளிகளை வரவேற்கிறோம்.',
            imgCaption: 'ஜொகூர் பாரு, மலேசியா',
            imgAlt: 'விளக்கப்படம்: ஆரோக்கியமான புன்னகை',
        },
        marquee: ['Good dentistry', 'Pergigian yang baik', '用心的牙科', 'நல்ல பல் சிகிச்சை', 'Honest advice', 'Nasihat yang jujur', '诚实的建议', 'நேர்மையான ஆலோசனை', 'Transparent fees', 'Yuran yang telus', '透明的收费', 'வெளிப்படையான கட்டணம்', 'Human care', 'Penjagaan yang manusiawi', '人性化的关怀', 'மனிதநேயமான கவனிப்பு'],
        pathways: {
            eyebrow: 'எங்கிருந்து தொடங்கலாம்?',
            title: 'உங்கள் புன்னகையில் என்ன மாற்ற விரும்புகிறீர்கள்?',
            sub: 'உங்கள் நிலையைச் சொல்லுங்கள்; சரியான தகவலுக்கும், சரியான உரையாடலுக்கும் நாங்கள் அழைத்துச் செல்கிறோம்.',
            items: [
                { id: 'straighter', label: 'என் பற்கள் நேராக வேண்டும்.', to: '/treatments/conventional-braces' },
                { id: 'discreet', label: 'குறைவாகத் தெரியும் வழியில் பற்களை நேர்க்க வேண்டும்.', to: '/treatments/clear-aligners' },
                { id: 'brighter', label: 'பிரகாசமான, அழகான புன்னகை வேண்டும்.', to: '/treatments/aesthetic-veneers' },
                { id: 'shape', label: 'பற்களின் வடிவம்/விகிதத்தை மாற்ற வேண்டும்.', to: '/treatments/aesthetic-veneers' },
                { id: 'broken', label: 'என் முன் பல் உடைந்தது / சேதமானது.', to: '/treatments/frc' },
                { id: 'restore', label: 'சேதமான பற்களை மீட்டமைக்க வேண்டும்.', to: '/treatments/zirconia-crowns-bridges' },
                { id: 'teen', label: 'என் பதின்ம வயது பிள்ளைக்கு பிரேசஸ் வேண்டும்.', to: '/teen-smile' },
                { id: 'sg', label: 'நான் சிங்கப்பூரிலிருந்து வருகிறேன்.', to: '/international/singapore' },
                { id: 'id', label: 'நான் இந்தோனேசியாவிலிருந்து வருகிறேன்.', to: '/international/indonesia-batam' },
                { id: 'unsure', label: 'எனக்கு என்ன தேவை என்று தெரியவில்லை.', to: '/contact' },
            ],
        },
        pillars: {
            eyebrow: 'எங்கள் ஐந்து தூண்கள்',
            title: 'கவனமான கவனிப்பு, தெளிவான விளக்கம்',
            sub: 'நாங்கள் ஐந்து சிகிச்சைத் துறைகளில் கவனம் செலுத்துகிறோம் — நன்றாகச் செய்யவும், நேர்மையாக விளக்கவும்.',
            ctaCard: { title: 'எந்தச் சிகிச்சை பொருத்தம் என்று தெரியவில்லையா?', text: 'ஒரு உரையாடலிலிருந்து தொடங்குங்கள் — விருப்பங்களைப் புரிந்துகொள்ள உதவுவோம்.', cta: 'ஆலோசனைத் திட்டமிடு' },
        },
        why: {
            eyebrow: 'நோயாளிகள் ஏன் எங்களைத் தேர்வு செய்கிறார்கள்',
            title: 'நோயாளிகள் நினைவில் கொள்வது',
            items: [
                { title: 'நேர்மையான ஆலோசனை', text: 'சிகிச்சை தேவையில்லை என்றால் நாங்கள் சொல்வோம்; சிறந்த விருப்பம் இருந்தால் அதையும் சொல்வோம்.' },
                { title: 'வெளிப்படையான சிகிச்சைக் கலந்துரையாடல்', text: 'விருப்பங்களும் கட்டணமும் சிகிச்சைக்கு முன்பே தெளிவாக விளக்கப்படும்.' },
                { title: 'மனிதநேயமான கவனிப்பு', text: 'கேட்ட மருத்துவரையும், நம்பக்கூடிய மருத்துவரையும் நோயாளிகள் நினைவில் கொள்கிறார்கள்.' },
                { title: 'மருத்துவ அனுபவம்', text: 'கவனமான மதிப்பீடு, அக்கறையுடன் சிகிச்சை.' },
                { title: 'நவீன பல் மருத்துவம்', text: 'மருத்துவ ரீதியாகப் பொருந்தினால் டிஜிட்டல் தொழில்நுட்பம் ஆதரவளிக்கும்.' },
            ],
        },
        doctors: {
            eyebrow: 'உங்கள் மருத்துவர்களை அறிந்துகொள்ள',
            title: 'Dr. Irma & Dr. Ariandi',
            sub: 'இரண்டு மருத்துவர்கள், ஒரே அணுகுமுறை: கவனமாகப் பரிசோதித்தல், தெளிவாக விளக்குதல், அன்பாகச் சிகிச்சையளித்தல்.',
            irmaLine: 'பல் மருத்துவர் · பல் கல்வியாளர் · எழுத்தாளர் — முன்பு Utusan Malaysia-ல் வழக்கமான சுகாதாரக் கலங்களை எழுதியவர்.',
            ariandiLine: 'பல் மருத்துவர்',
            cta: 'மருத்துவர்களை அறிந்துகொள்ள',
        },
        teen: {
            eyebrow: 'Teen Smile',
            title: 'பதின்ம வயது பிரேசஸ் பற்றிய பெற்றோர் வழிகாட்டி',
            text: 'ஜொகூர் பாரு பெற்றோருக்கான நேர்மையான வழிகாட்டி — சரியான வயது, முதல் மதிப்பீடு, அமைதியான முடிவு.',
            points: [
                'அழுத்தமின்றி முதல் மதிப்பீடு',
                'பிரேசஸ் vs clear aligners',
                'சிகிச்சையின் போது பள்ளி, விளையாட்டு, சுகாதாரம்',
            ],
            cta: 'பெற்றோர் வழிகாட்டியைப் படிக்க',
        },
        intl: {
            eyebrow: 'சர்வதேச நோயாளிகள்',
            title: 'எல்லை தாண்டிய சிகிச்சை, சரியாகத் திட்டமிடப்பட்டது',
            sg: { title: 'சிங்கப்பூரிலிருந்து', text: 'ஜொகூர் பாருவில் clear aligner சிகிச்சை — பரிசோதனை வருகைகளை ஜொகூர் பயணத்துடன் இணைக்கலாம்.' },
            id: { title: 'இந்தோனேசியா / பத்தாமிலிருந்து', text: 'ஜொகூர் பாருவில் clear aligner மற்றும் தேர்ந்தெடுத்த மீட்டமைப்பு சிகிச்சை — எளிய பயண வழிகாட்டியுடன்.' },
            aligner: 'சர்வதேச நோயாளிகளுக்கு clear aligners தான் முக்கிய சிகிச்சை — மருத்துவ ரீதியாகப் பொருத்தமானால், சுமார் 3 மாதங்களுக்கு ஒருமுறை பரிசோதனைகள் திட்டமிடப்படுகின்றன.',
            note: 'தனிநபர் மருத்துவத் தேவைகள், சிகிச்சைத் திட்டம், கிளினிக்/வழங்குநர் விதிமுறைகள் மற்றும் பொருந்தும் டெலிவரி தேவைகளுக்கு உட்பட்டது.',
            cta: 'சர்வதேச நோயாளிகள்',
        },
        digital: {
            eyebrow: 'எங்கள் தொழில்நுட்பம்',
            title: 'WE EMBRACE DIGITAL DENTISTRY',
            p1: 'நவீன பல் மருத்துவம் என்பது நாம் என்ன செய்கிறோம் என்பது மட்டுமல்ல — எப்படித் திட்டமிடுகிறோம் என்பதும்.',
            p2: 'இங்கே டிஜிட்டல் தொழில்நுட்பம் நோய் கண்டறிதல், சிகிச்சைத் திட்டமிடல் மற்றும் மீட்டமைப்பு/அழகியல் பணிகளின் தேர்ந்தெடுத்த பகுதிகளில் ஆதரவளிக்கிறது. இன்ட்ராஓரல் ஸ்கேனிங் பொருந்தினால், பாரம்பரிய முத்திரைகளை மட்டும் சார்ந்திராமல் பற்களின் டிஜிட்டல் பதிவை எடுக்க முடியும்.',
            note: 'தொழில்நுட்பம் மருத்துவத் தீர்ப்பை ஆதரிக்கும் — மாற்றாது.',
            cta: 'டிஜிட்டல் டென்டிஸ்ட்ரியைத் தெரிந்துகொள்',
        },
        veneers: {
            eyebrow: 'Aesthetic Veneers & Smile Makeover',
            title: 'உங்களுக்காக வடிவமைக்கப்படும் புன்னகை',
            text: 'புன்னகையின் நிறம், வடிவம், விகிதம், சமச்சீர்மையை மேம்படுத்த விரும்புவோருக்கு, சரியான மதிப்பீட்டுக்குப் பிறகு veneers ஒரு விருப்பமாக இருக்கலாம். ஒவ்வொரு புன்னகையும் தனித்தன்மையானது.',
            artist: { title: 'THE ARTIST SMILE', text: 'பிரகாசமான, பாலிஷ் செய்யப்பட்ட, காமெரா-தயார் அழகியலை விரும்புவோருக்கு. சிலர் இயற்கையான நிழலை விரும்புகிறார்கள்; சிலர் பிரகாசமானதை — இது திட்டமிடலில் கலந்துரையாடப்படும்.' },
            cta: 'புன்னகை ஆலோசனைத் திட்டமிடு',
            ctaWa: 'VENEER சிகிச்சை கேளுங்கள்',
        },
        kolum: {
            eyebrow: 'Coffee With Dr. Irma',
            title: 'பல் மருத்துவக் கூடத்திலிருந்து கலங்கள்',
            sub: 'Dr. Irma Ariandi பற்கள், நேர்மை, வாழ்க்கை பற்றி எழுதுகிறார் — அவரது சுகாதாரக் கலம் பாரம்பரியத்தைத் தொடர்கிறது.',
            empty: 'இந்த மொழியிலான கலங்கள் தயாராகிக்கொண்டிருக்கின்றன. அதற்குப் பதிலாக மற்ற மொழிகளில் கட்டுரைகளைப் பாருங்கள்.',
            cta: 'Dr. Irma கலங்களைப் படிக்க',
        },
        remember: {
            eyebrow: 'நோயாளிகள் நினைவில் கொள்வது',
            title: 'நோயாளிகள் நினைவில் கொள்வது',
            sub: 'சரிபார்க்கப்பட்ட நோயாளிகளின் உண்மையான வார்த்தைகள் — அனுமதியுடன், பெயரின்றி. அப்படியே, அந்த மொழியிலேயே வெளியிடப்படுகிறது.',
            themes: ['வெளிப்படையான கட்டணம்', 'நேர்மையான ஆலோசனை', 'நட்பான மருத்துவர்', 'நம்பகமான மருத்துவம்', 'மனிதநேயமான கவனிப்பு'],
            verifiedLabel: 'உறுதிசெய்யப்பட்ட நோயாளி',
        },
        journey: {
            eyebrow: 'எங்கள் கொள்கை',
            title: 'முதலில் புரிந்துகொள்ளுங்கள். பிறகு முடிவெடுங்கள்.',
        },
        nervous: {
            title: 'பல் மருத்துவரிடம் செல்லப் பயமா?',
            text: 'எங்களிடம் சொல்லுங்கள். நாங்கள் புரிகிறோம். எங்கள் பல நோயாளிகள் பயம் இருந்ததைச் சொன்னார்கள் — நாங்கள் நேரம் எடுத்து விளக்குகிறோம்; வேகம் உங்களுடையது.',
            cta: 'WhatsApp-ல் எங்களிடம் சொல்லுங்கள்',
        },
        location: {
            eyebrow: 'எங்களைச் சந்திக்க',
            title: 'ஜொகூர் பாருவில் எங்களைக் காண்பிங்கள்',
            addressLabel: 'முகவரி',
            addressValue: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
            hoursLabel: 'வேலை நேரம்',
            hoursValue: 'ஞாயிறு–வியாழன்: காலை 10:00 – மாலை 6:00 (மதிய ஓய்வு 1:00 – 2:00) · சனி: காலை 9:00 – 12:30 · வெள்ளி & பொது விடுமுறை: மூடும் · முன்பதிவு மட்டும்',
            mapNote: 'எங்கள் கிளினிக் Plaza Larkin மாடி 1-ல் உள்ளது (மேலே உள்ள கட்டிடம்).',
            whatsappLabel: 'WhatsApp',
            emailLabel: 'மின்னஞ்சல்',
        },
        finalCta: {
            title: 'WEAR YOUR SMILE.',
            sub: 'ஒரு உரையாடலிலிருந்து தொடங்குங்கள். உங்கள் கவலையைச் சுருக்கமாகச் சொன்னால், அடுத்த சரியான படியை நாங்கள் காட்டுவோம்.',
            primary: 'கிளினிக்கை WhatsApp செய்யுங்கள்',
            secondary: 'நேரம் பதிவு',
        },
    },
    treatLabels: {
        who: 'இந்தச் சிகிச்சையை யார் கருத்தில் கொள்ளலாம்',
        problem: 'இது எந்தப் பிரச்சனையைத் தீர்க்கிறது',
        assessment: 'மதிப்பீடு எவ்வாறு நடைபெறுகிறது',
        options: 'சிகிச்சை விருப்பங்கள்',
        journey: 'சிகிச்சைப் பயணம்',
        know: 'நோயாளிகள் அறிந்திருக்க வேண்டியவை',
        followup: 'தொடர் கண்காணிப்பு குறிப்புகள்',
        faq: 'அடிக்கடி கேட்கப்படும் கேள்விகள்',
        doctors: 'உங்கள் மருத்துவர்கள்',
        articles: 'தொடர்புடைய வாசிப்பு',
        teenNoteLabel: 'பதின்ம வயதினருக்கு — பெற்றோர் அறிந்திருக்க வேண்டியது',
        intlNoteLabel: 'சர்வதேச நோயாளிகள்',
        ctaTitle: 'இன்னும் யோசிக்கிறீர்களா?',
        ctaText: 'கிளினிக்கிற்கு செய்தி அனுப்புங்கள். இந்தச் சிகிச்சை உங்களுக்குப் பொருத்தமா என்று நேர்மையாக விளக்குவோம்.',
        digital: 'டிஜிட்டல் டென்டிஸ்ட்ரி ஆதரவு',
    },
    teen: {
        metaTitle: 'Teen Smile: பெற்றோர் வழிகாட்டி | இர்மா அரியாண்டி பல் கிளினிக்',
        metaDesc: 'ஜொகூர் பாரு பெற்றோருக்கான நேர்மையான வழிகாட்டி: பிரேசஸ் சரியான வயது, முதல் மதிப்பீடு, பள்ளி வாழ்க்கை.',
        title: 'Teen Smile',
        subtitle: 'பெற்றோர் வழிகாட்டி',
        heroText: 'பிரேசஸ் கேட்பது உங்கள் பிள்ளை அல்ல — ஆராய்வது நீங்கள்; அதுவே சரியான படி. இந்தப் பக்கம் ஜொகூர் பாரு பெற்றோருக்காக எழுதப்பட்டது.',
        ctaTitle: 'உங்கள் பிள்ளையின் பற்கள் பற்றி கேள்விகளா?',
        ctaText: 'எங்கள் கிளினிக்கை WhatsApp செய்யுங்கள். பிள்ளையின் வயதையும் உங்கள் முக்கிய கவலையையும் சொல்லுங்கள்.',
    },
    international: {
        metaTitle: 'சர்வதேச நோயாளிகள் — சிங்கப்பூர் & இந்தோனேசியா | இர்மா அரியாண்டி',
        metaDesc: 'சிங்கப்பூர், பத்தாம் மற்றும் இந்தோனேசியாவிலிருந்து வரும் நோயாளிகளுக்கு ஜொகூர் பாருவில் பல் சிகிச்சை.',
        title: 'சர்வதேச நோயாளிகள்',
        subtitle: 'சிங்கப்பூர் · இந்தோனேசியா / பத்தாம்',
        heroText: 'சிங்கப்பூர் மற்றும் இந்தோனேசியாவிலிருந்து வரும் நோயாளிகளை நாங்கள் பெறுகிறோம் — குறிப்பாக clear aligner மற்றும் தேர்ந்தெடுத்த மீட்டமைப்பு சிகிச்சைகளுக்கு.',
    },
    kolum: {
        tagline: 'Dental Health · Smiles · Modern Dentistry',
        metaTitle: 'Coffee With Dr. Irma | இர்மா அரியாண்டி பல் கிளினிக்',
        metaDesc: 'Dr. Irma Ariandi (DDS, UKM) எழுதும் பல் சுகாதாரக் கலங்கள் — ஜொகூர் பாரு பல் மருத்துவர்.',
        title: 'Coffee With Dr. Irma',
        sub: 'Dr. Irma Ariandi, DDS (UKM) எழுதும் கலங்கள் — பல் மருத்துவர், கல்வியாளர், எழுத்தாளர்.',
        all: 'அனைத்தும்',
        by: 'எழுதியவர்',
        minRead: 'நிமிட வாசிப்பு',
        published: 'வெளியீடு',
        updated: 'புதுப்பிக்கப்பட்டது',
        empty: 'இந்த மொழியிலான கலங்கள் தயாராகிக்கொண்டிருக்கின்றன. மற்ற மொழிகளில் படியுங்கள்.',
        langOf: 'மொழி',
        back: 'அனைத்துக் கலங்கள்',
        stillUnsure: {
            title: 'இன்னும் உறுதியாக இல்லையா?',
            text: 'Dr. Irma-விடம் கேளுங்கள். உங்கள் கவலையைச் சுருக்கமாகச் சொல்லுங்கள்; அடுத்த சரியான படியை எங்கள் குழு வழிகாட்டும்.',
            cta: 'கிளினிக்கை WhatsApp செய்யுங்கள்',
            note: 'WhatsApp தொடர்பு உங்களை வழிநடத்த உதவும் — அது நோய் கண்டறிதல் அல்ல.',
        },
        relatedTreatment: 'தொடர்புடைய சிகிச்சை',
        authorLine: 'எழுதியது: Dr. Irma (DDS, UKM), Klinik Pergigian Irma Ariandi.',
        sampleNote: 'மாதிரிக் கலம் — அதிகாரப்பூர்வ வெளியீட்டுக்கு முன் கிளினிக் மதிப்பாய்வு செய்யப்படும்.',
    },
    doctors: {
        metaTitleIrma: 'Dr. Irma (DDS, UKM) — பல் மருத்துவர், கல்வியாளர், எழுத்தாளர் | ஜொகூர் பாரு',
        metaDescIrma: 'Dr. Irma Ariandi, DDS (UKM) — ஜொகூர் பாரு பல் மருத்துவர், பல் கல்வியாளர், Utusan Malaysia முன்னாள் சுகாதாரக் கலங்கள் எழுதியவர்.',
        metaTitleAriandi: 'Dr. Ariandi (DDS, UKM) — பல் மருத்துவர் | இர்மா அரியாண்டி பல் கிளினிக்',
        metaDescAriandi: 'Dr. Ariandi, DDS (UKM) — ஜொகூர் பாரு Klinik Pergigian Irma Ariandi-ன் பல் மருத்துவர்.',
        profile: 'மருத்துவர் சுயவிவரம்',
        quals: 'தகுதிகள்',
        interests: 'சிகிச்சை ஆர்வங்கள்',
        philosophy: 'சிகிச்சைக் கொள்கை',
        articlesBy: 'கலங்கள்',
        pendingBio: '[மருத்துவர் வரலாறு உறுதிப்படுத்தப்பட வேண்டும்]',
        pendingInterests: '[சிகிச்சை ஆர்வங்கள் உறுதிப்படுத்தப்பட வேண்டும்]',
        pendingPhilosophy: '[சிகிச்சைக் கொள்கை உறுதிப்படுத்தப்பட வேண்டும்]',
        cta: 'நேரம் பதிவு:',
        irmaRoles: 'பல் மருத்துவர் · பல் கல்வியாளர் · எழுத்தாளர்',
        irmaColumnist: 'Dr. Irma முன்பு Utusan Malaysia-ல் வழக்கமான சுகாதாரக் கலங்களை எழுதினார். இந்த டிஜிட்டல் கலம் அந்த எழுத்துப் பாரம்பரியத்தைத் தொடர்கிறது.',
        ariandiRoles: 'பல் மருத்துவர்',
    },
    stories: {
        metaTitle: 'நோயாளிகள் நினைவில் கொள்வது | இர்மா அரியாண்டி',
        metaDesc: 'உண்மையான மதிப்புரைகள் — சரிபார்ப்பு மற்றும் அனுமதியுடன் மட்டுமே வெளியிடப்படும்.',
        title: 'நோயாளிகள் நினைவில் கொள்வது',
        sub: 'சரிபார்க்கப்பட்ட நோயாளிகளின் உண்மையான வார்த்தைகள் — அனுமதியுடன், பெயரின்றி. அப்படியே, அந்த மொழியிலேயே வெளியிடப்படுகிறது. நாங்கள் திருத்தவோ, அலங்கரிக்கவோ செய்வதில்லை.',
        themesTitle: 'நோயாளிகள் குறிப்பிடும் கருப்பொருள்கள்',
        verifiedLabel: 'உறுதிசெய்யப்பட்ட நோயாளி',
        caseTitle: 'வழக்குக் கதைகள்',
        caseNote: 'உண்மையான வழக்குக் கதைகள் — நோயாளியின் எழுத்துப்பூர்வ ஒப்புதலுடன் மட்டுமே வெளியிடப்படும்.',
        caseSlot: '[உண்மையான வழக்குக் கதை இணைக்கப்பட வேண்டும்]',
    },
    about: {
        metaTitle: 'கிளினிக் பற்றி | இர்மா அரியாண்டி, ஜொகூர் பாரு',
        metaDesc: 'ஜொகூர் பாருவில் உள்ள பல் கிளினிக் — நல்ல சிகிச்சை, நேர்மையான ஆலோசனை, வெளிப்படையான கட்டணம்.',
        title: 'கிளினிக் பற்றி',
        intro: 'Klinik Pergigian Irma Ariandi மலேசியா, ஜொகூரின் ஜொகூர் பாருவில் உள்ள பல் கிளினிக். நாங்கள் ஐந்து சிகிச்சைத் துறைகளில் கவனம் செலுத்துகிறோம் — ஒரே வாக்குறுதியுடன்: பிரேசஸ், clear aligners, FRC, சிர்க்கோனியா கிரீடம் & பிரிட்ஜ், aesthetic veneers & smile makeover.',
        promisesTitle: 'எங்கள் வாக்குறுதி',
        promises: [
            { t: 'நல்ல பல் சிகிச்சை', d: 'தெளிவான காரணத்துடன், கவனமான வேலை.' },
            { t: 'நேர்மையான ஆலோசனை', d: 'நாங்கள் சொல்வதே நாங்கள் செய்வது — அல்லது செய்யாதது.' },
            { t: 'வெளிப்படையான கட்டணம்', d: 'சிகிச்சைக்கு முன் தெளிவாக விளக்கப்படும்.' },
            { t: 'மனிதநேயமான கவனிப்பு', d: 'நீங்கள் வரிசை எண் அல்ல; நீங்கள் நமக்குத் தெரிந்த நோயாளி.' },
        ],
        philosophyTitle: 'எங்கள் சிகிச்சைக் கொள்கை',
        photoSlot: '[கிளினிக் புகைப்படம் இணைக்கப்பட வேண்டும்]',
    },
    contact: {
        metaTitle: 'தொடர்பு / நேரம் பதிவு | இர்மா அரியாண்டி, ஜொகூர் பாரு',
        metaDesc: 'WhatsApp 011-3306 5735 அல்லது மின்னஞ்சல் மூலம் தொடர்பு கொள்ளுங்கள். எளிய முன்பதிவு படிவம்.',
        title: 'எங்களைத் தொடர்பு கொள்ள',
        sub: 'வேகமான வழி WhatsApp. படிவத்தை விரும்பினாலும் உதவ நாங்கள் தயார்.',
        whatsappTitle: 'WhatsApp (வேகமானது)',
        emailTitle: 'மின்னஞ்சல் / முன்பதிவு',
        addressTitle: 'முகவரி',
        addressValue: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
        hoursTitle: 'வேலை நேரம்',
        hoursValue: 'ஞாயிறு–வியாழன்: காலை 10:00 – மாலை 6:00 (மதிய ஓய்வு 1:00 – 2:00) · சனி: காலை 9:00 – 12:30 · வெள்ளி & பொது விடுமுறை: மூடும் · முன்பதிவு மட்டும்',
        formTitle: 'எளிய விசாரணைப் படிவம்',
        form: {
            name: 'பெயர்',
            namePh: 'உங்கள் பெயர்',
            method: 'எப்படித் தொடர்பு கொள்ள விரும்புகிறீர்கள்?',
            methodOptions: ['WhatsApp', 'தொலைபேசி', 'மின்னஞ்சல்'],
            treatment: 'விருப்பமான சிகிச்சை',
            treatmentOptions: ['பிரேசஸ்', 'Clear aligners', 'FRC', 'சிர்க்கோனியா கிரீடம் & பிரிட்ஜ்', 'Aesthetic veneers', 'இன்னும் தெரியவில்லை', 'மற்றவை'],
            phoneLabel: 'WhatsApp / தொலைபேசி எண்',
            phonePh: '12-345 6789',
            dateLabel: 'விரும்பிய சந்திப்பு தேதி',
            timeLabel: 'விரும்பிய நேரம்',
            timeOptions: ['காலை (10:00 – 13:00)', 'மதியம் (13:00 – 15:00)', 'மாலை (15:00 – 18:00)'],
            successTitle: 'சந்திப்பு கோரிக்கை பெறப்பட்டது',
            successBody: 'கிளினிக் குழு காலத்தைச் சரிபார்த்து உறுதிப்படுத்த உங்களைத் தொடர்பு கொள்ளும். உங்கள் விவரங்கள் ஏற்கனவே Aira உடன் பகிரப்பட்டுள்ளன — மீண்டும் சொல்ல தேவையில்லை.',
            successAira: 'Aira உடன் தொடரவும்',
            successWa: 'WhatsApp க்குச் செல்லவும்',
            time: 'விருப்பமான நேரம்',
            timePh: 'எ.கா: இந்த வார இறுதி, மதியம்',
            country: 'நீங்கள் இருப்பது',
            countryOptions: ['மலேசியா', 'சிங்கப்பூர்', 'இந்தோனேசியா', 'மற்றவை'],
            message: 'சுருக்கமான செய்தி',
            messagePh: 'உங்கள் கவலையைச் சுருக்கமாகச் சொல்லுங்கள்',
            submit: 'விசாரணை அனுப்பு',
            success: 'நன்றி. கிளினிக் விரைவில் தொடர்பு கொள்ளும்.',
            error: 'மன்னிக்கவும், அனுப்ப முடியவில்லை. நேரடியாக WhatsApp செய்யுங்கள்.',
            consent: 'இந்தப் படிவத்தை சமர்ப்பிப்பதன் மூலம், உங்கள் விசாரணை குறித்து உங்களைத் தொடர்பு கொள்ள ஒப்புக்கொள்கிறீர்கள்.',
        },
    },
    privacy: {
        metaTitle: 'தனியுரிமைக் கொள்கை | இர்மா அரியாண்டி பல் கிளினிக்',
        metaDesc: 'உங்கள் விசாரணைத் தகவல் எவ்வாறு சேகரிக்கப்பட்டு, பயன்படுத்தப்பட்டு, பாதுகாக்கப்படுகிறது.',
        title: 'தனியுரிமைக் கொள்கை',
        updated: 'பதிப்பு 1.0 — [தேதி உறுதிப்படுத்தப்பட வேண்டும்]',
        sections: [
            { h: 'நாங்கள் சேகரிப்பது', p: 'விசாரணைப் படிவம் அல்லது WhatsApp வழியாக நீங்கள் வழங்கும் தகவல் மட்டுமே — பெயர், தொடர்பு முறை, விசாரணைச் சுருக்கம்.' },
            { h: 'பயன்பாடு', p: 'உங்கள் தகவல் விசாரணைக்குப் பதிலளிக்கவும் முன்பதிவுகளை நிர்வகிக்கவும் மட்டுமே பயன்படுத்தப்படுகிறது.' },
            { h: 'குக்கீகள்', p: 'இணையதளப் பயன்பாட்டை மொத்தத்தில் புரிந்துகொள்ள அனலிட்டிக்ஸ் பயன்படுத்தப்படலாம்; தனிநபராக அடையாளம் காணப் பயன்படுவதில்லை.' },
            { h: 'சேமிப்பு', p: 'விசாரணைகள் பாதுகாப்பாகச் சேமிக்கப்பட்டு, கிளினிக் குழுவால் மட்டுமே அணுகப்படுகின்றன.' },
            { h: 'உங்கள் உரிமைகள்', p: 'உங்கள் தரவு குறித்து: klinikpergigianirmaariandi@gmail.com.' },
        ],
    },
    disclaimer: {
        metaTitle: 'இணையதள & மருத்துவ மறுப்பு | இர்மா அரியாண்டி',
        metaDesc: 'இந்த இணையதளத் தகவல் கல்விக்கானது; மருத்துவப் பரிசோதனைக்கு மாற்றானது அல்ல.',
        title: 'இணையதள & மருத்துவ மறுப்பு',
        updated: 'பதிப்பு 1.0 — [தேதி உறுதிப்படுத்தப்பட வேண்டும்]',
        sections: [
            { h: 'கல்விசார் தகவல்', p: 'இந்த இணையதளத்தின் உள்ளடக்கம் கல்வி மற்றும் பொதுத் தகவலுக்கானது; தனிநபர் மருத்துவப் பரிசோதனைக்கு மாற்றானது அல்ல.' },
            { h: 'தனிநபர் மதிப்பீடு', p: 'சிகிச்சைப் பொருத்தம், கால அளவு, வருகைகள், முடிவுகள் நோயாளிக்கு நோயாளி வேறுபடும்.' },
            { h: 'WhatsApp நோய் கண்டறிதல் அல்ல', p: 'WhatsApp தொடர்பு சரியான அடுத்த படியைக் காட்ட உதவுகிறது; அது நோய் கண்டறிதல் அல்ல.' },
            { h: 'உத்தரவாதங்கள் இல்லை', p: 'நாங்கள் நேர்மையான விளக்கத்தையும், வெளிப்படையான கட்டணத்தையும் மட்டுமே உறுதி செய்கிறோம்.' },
        ],
    },
    notFound: {
        title: 'இந்தப் பக்கம் இல்லை',
        text: 'இணைப்பு தவறாக இருக்கலாம், அல்லது பக்கம் கட்டமைப்பில் உள்ளது.',
        cta: 'முதற்பக்கம்',
    },
    footer: {
        about: 'ஜொகூர் பாருவில் உள்ள பல் கிளினிக். பிரேசஸ், clear aligners, FRC, சிர்க்கோனியா, aesthetic veneers.',
        quickLinks: 'விரைவு இணைப்புகள்',
        treatments: 'சிகிச்சைகள்',
        international: 'சர்வதேச நோயாளிகள்',
        kolum: 'Coffee With Dr. Irma',
        doctors: 'மருத்துவர்கள்',
        contact: 'தொடர்பு',
        privacy: 'தனியுரிமைக் கொள்கை',
        disclaimer: 'இணையதள & மருத்துவ மறுப்பு',
        whatsapp: 'WhatsApp',
        email: 'மின்னஞ்சல்',
        address: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
        addressSlot: '',
        rights: 'Klinik Pergigian Irma Ariandi. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.',
        disclaimerLine: 'இந்த இணையதளத் தகவல் கல்விக்கானது; மருத்துவப் பரிசோதனைக்கு மாற்றானது அல்ல.',
    },
};
